import { useMemo, useState } from 'react';
import {
  getPreviousMonthVsPriorMonth,
  getPreviousWeekVsPriorWeek,
  isRangeValid,
  type DateRange,
} from '@/api/reportDateRanges';

export type RecommendationRangePreset = 'lastMonth' | 'lastWeek' | 'custom';

export function useRecommendationDateRange() {
  const defaultRange = useMemo(() => getPreviousMonthVsPriorMonth().periodA, []);
  const [preset, setPreset] = useState<RecommendationRangePreset>('lastMonth');
  const [customRange, setCustomRange] = useState<DateRange>(defaultRange);

  const range = useMemo(() => {
    if (preset === 'lastMonth') return getPreviousMonthVsPriorMonth().periodA;
    if (preset === 'lastWeek') return getPreviousWeekVsPriorWeek().periodA;
    return customRange;
  }, [preset, customRange.startDate, customRange.endDate]);

  const invalidRange = !isRangeValid(range);

  return {
    preset,
    setPreset,
    customRange,
    setCustomRange,
    range,
    invalidRange,
  };
}
